"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _utils = require("../utils");
var _use = (0, _utils.use)('steps'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  props: {
    active: Number,
    activeColor: String,
    activeTextColor: {
      type: String,
      default: '#666666'
    },
    deactiveTextColor: {
      type: String,
      default: '#c6c6c6'
    },
    iconSize: {
      // horizontal模式下的icon大小
      type: Number,
      default: 12
    },
    opacity: {
      type: Number,
      default: 1
    },
    bgColor: {
      type: String,
      default: '#D8D8D8'
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator: function validator(val) {
        return ['horizontal', 'vertical'].includes(val);
      }
    }
  },
  data: function data() {
    return {
      steps: [],
      offsetTop: 0,
      clientWidth: 0,
      dayWidth: 0 // use for children
    };
  },

  computed: {
    padding: function padding() {
      if (this.direction === 'vertical') return;
      var padding = 20;
      switch (this.steps.length) {
        case 0:
        case 1:
        case 2: // 基于UI规范的话，以上情况理论上不会出现
        case 3:
          padding = 48;
          break;
        case 4:
          padding = 36;
          break;
        case 5:
          padding = 30;
          break;
        default:
          break;
      }
      return padding;
    },
    progressWidth: function progressWidth() {
      return this.steps.length > 1 ? this.clientWidth - this.padding * 2 - this.iconSize : 0;
    },
    progressStyle: function progressStyle() {
      return {
        top: this.offsetTop + this.iconSize / 2 + "px",
        left: this.padding + this.iconSize / 2 + "px",
        width: this.progressWidth + "px",
        backgroundColor: this.bgColor,
        opacity: this.opacity
      };
    },
    activeStyle: function activeStyle() {
      var percent = this.steps.length > 1 ? (this.active + 0.5) / (this.steps.length - 1) : 0;
      return {
        top: this.offsetTop + this.iconSize / 2 + "px",
        left: this.padding + this.iconSize / 2 + "px",
        width: this.progressWidth * Math.min(percent, 1) + "px",
        backgroundColor: this.activeColor
      };
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.init();
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;
      // 因为computed第一次执行在挂载前，且$el的变化不会触发重新计算
      this.clientWidth = this.$refs.steps.clientWidth;
      this.offsetTop = this.steps.length ? this.steps[0].$el.offsetTop : 0;

      // 不同的数字，宽度会不一样，导致分割线对不齐，以此修正
      if (this.direction === 'vertical') {
        this.$children.forEach(function (item) {
          if (!item.$refs.day) return;
          var width = item.$refs.day.clientWidth;
          if (width > _this2.dayWidth) {
            _this2.dayWidth = width;
          }
        });
      }
    }
  },
  render: function render(h) {
    return h("div", {
      "class": bem('container')
    }, [h("div", {
      "ref": "steps",
      "class": bem('', this.direction),
      "style": {
        paddingLeft: this.padding + "px",
        paddingRight: this.padding + "px"
      }
    }, [this.slots(), h("div", {
      "class": bem('progress'),
      "style": this.progressStyle
    }), h("div", {
      "class": bem('progress-bar'),
      "style": this.activeStyle
    })])]);
  }
});
exports.default = _default;